const map = {
	"./alert-2.svg": 22791,
	"./alert-triangle.svg": 38263,
	"./alert.svg": 49998,
	"./arrow-circle-broken-right.svg": 7287,
	"./arrow-down.svg": 43668,
	"./arrow-left.svg": 96691,
	"./arrow-right.svg": 7350,
	"./arrow-up.svg": 92719,
	"./badge.svg": 77133,
	"./bar-chart-01.svg": 95592,
	"./bar-chart-10-solid.svg": 92732,
	"./bar-chart-10.svg": 21038,
	"./bar-chart-square-01.svg": 94968,
	"./bar-chart-square-02-16.svg": 71817,
	"./bar-chart-square-02.svg": 33803,
	"./book-closed.svg": 53004,
	"./book-open-01.svg": 52360,
	"./brackets-ellipses.svg": 94377,
	"./brackets-x.svg": 4964,
	"./calendar-minus-01.svg": 1731,
	"./caret-sort-down.svg": 82903,
	"./caret-sort-up.svg": 48680,
	"./caret-sort.svg": 86062,
	"./chart-breakout-square-16.svg": 54702,
	"./chart-breakout-square.svg": 16082,
	"./check-01.svg": 11624,
	"./check-circle-broken.svg": 43553,
	"./check-circle-green.svg": 93423,
	"./check-circle.svg": 86313,
	"./check-done-01-16.svg": 89441,
	"./check-done-01.svg": 6979,
	"./check-undone-01-16.svg": 84988,
	"./check-undone-01.svg": 37968,
	"./chevron-down-small.svg": 53920,
	"./chevron-down.svg": 40506,
	"./chevron-left.svg": 2705,
	"./chevron-right.svg": 66204,
	"./circle.svg": 10568,
	"./clipboard-02.svg": 57885,
	"./clock-fast-forward.svg": 23057,
	"./clock.svg": 142,
	"./close.svg": 93224,
	"./coins-hand.svg": 11468,
	"./coins-stacked-02.svg": 75413,
	"./copy-06.svg": 80178,
	"./copy-07-16.svg": 18753,
	"./copy-07.svg": 13219,
	"./copy.svg": 51827,
	"./credit-card-02.svg": 6773,
	"./currency-euro-circle.svg": 37482,
	"./currency-euro.svg": 19773,
	"./dot-solid-green.svg": 85641,
	"./dot-solid-orange.svg": 51294,
	"./dot-solid-red.svg": 42637,
	"./dots-horizontal.svg": 50413,
	"./download-01.svg": 21800,
	"./download.svg": 73468,
	"./drag-handle-dots-2.svg": 7631,
	"./edit-02.svg": 12703,
	"./edit-2.svg": 10013,
	"./esim-iot.svg": 27541,
	"./expired-link.svg": 65816,
	"./external-link.svg": 53806,
	"./eye-off.svg": 66579,
	"./eye.svg": 28395,
	"./file-code-01.svg": 70728,
	"./file-download-03.svg": 85255,
	"./filter-lines.svg": 27960,
	"./fingerprint-04.svg": 28417,
	"./flip-backward.svg": 21185,
	"./globe-01.svg": 63629,
	"./globe-x.svg": 92,
	"./globe.svg": 91619,
	"./google.svg": 41233,
	"./home-solid.svg": 3863,
	"./home.svg": 55441,
	"./info-circle.svg": 23285,
	"./information.svg": 72222,
	"./key-01-solid.svg": 64053,
	"./key-01.svg": 70519,
	"./link-02.svg": 79011,
	"./list.svg": 34908,
	"./lock-01.svg": 48511,
	"./log-out-01.svg": 43279,
	"./mail.svg": 79977,
	"./marker-pin-01-16.svg": 74408,
	"./marker-pin-01.svg": 38084,
	"./maximize.svg": 7810,
	"./message-check-square-16.svg": 71102,
	"./message-check-square.svg": 77858,
	"./message-square-2.svg": 49494,
	"./microsoft.svg": 96576,
	"./minus.svg": 97660,
	"./moon-star.svg": 19512,
	"./no-data-bar-chart.svg": 25721,
	"./package-x.svg": 23115,
	"./package.svg": 96332,
	"./plug.svg": 55160,
	"./plus-badge-size-1-&-2.svg": 3434,
	"./plus-badge-size-3.svg": 31712,
	"./plus.svg": 55604,
	"./qr-code-02.svg": 54212,
	"./radio.svg": 62685,
	"./receipt.svg": 72024,
	"./refresh-cw-05.svg": 87512,
	"./repeat-03.svg": 28285,
	"./reverse-left.svg": 32632,
	"./search-dark-medium.svg": 63183,
	"./send-01-16.svg": 88618,
	"./send-01.svg": 25686,
	"./settings-01.svg": 88669,
	"./settings-02.svg": 76574,
	"./shield-plus.svg": 89592,
	"./shield-tick.svg": 7583,
	"./signal-01.svg": 57932,
	"./signal-03.svg": 8526,
	"./signal.svg": 26928,
	"./sim-2ff.svg": 42620,
	"./sim-activate.svg": 22497,
	"./sim-card-new.svg": 89389,
	"./sim-card-solid.svg": 92646,
	"./sim-deactivate.svg": 38736,
	"./sim-mff2.svg": 5279,
	"./sim-transferred.svg": 86664,
	"./sim.svg": 27177,
	"./simcard.svg": 20087,
	"./slash-circle-01.svg": 91664,
	"./softsim.svg": 47113,
	"./sun.svg": 90102,
	"./switch-horizontal-01.svg": 14315,
	"./tag-02-solid.svg": 93337,
	"./tag-02.svg": 56443,
	"./tag-03.svg": 96074,
	"./target-03.svg": 36675,
	"./terminal-browser.svg": 65595,
	"./trash-01.svg": 8618,
	"./trash-2.svg": 28907,
	"./upload-01.svg": 54809,
	"./upload-03.svg": 54427,
	"./user-03-solid.svg": 44207,
	"./user.svg": 98661,
	"./verify-email.svg": 17252,
	"./warning.svg": 91848,
	"./webhooks.svg": 85414,
	"./wow-mondo.svg": 66303,
	"./x-badge-size-1-&-2.svg": 86746,
	"./x-badge-size-3.svg": 69648,
	"./x-circle.svg": 92881
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73280;